export interface CachedDocument {
    dataUrl: string;
    bytes: number;
}

/** Visit-scoped cache of file bytes, not expiring signed URLs. No disk persistence. */
export class VisitDocumentCache {
    private entries = new Map<string, Promise<CachedDocument>>();
    private sizes = new Map<string, number>();
    constructor(private maxBytes = 40 * 1024 * 1024) {}
    get(key: string, load: () => Promise<CachedDocument>): Promise<CachedDocument> {
        const existing = this.entries.get(key);
        if (existing) {
            return existing;
        }
        const promise = load()
            .then((file) => {
                if (this.entries.get(key) !== promise) {
                    return file;
                }
                this.sizes.set(key, file.bytes);
                let total = [...this.sizes.values()].reduce((sum, size) => sum + size, 0);
                for (const [old, size] of this.sizes) {
                    if (total <= this.maxBytes) {
                        break;
                    }
                    this.entries.delete(old);
                    this.sizes.delete(old);
                    total -= size;
                }
                return file;
            })
            .catch((error) => {
                if (this.entries.get(key) === promise) {
                    this.entries.delete(key);
                }
                throw error;
            });
        this.entries.set(key, promise);
        return promise;
    }
    clear() {
        this.entries.clear();
        this.sizes.clear();
    }
}
